import { Modal } from "ant-design-vue";
import { h } from "vue";

export function useNotificationPermission() {
  // 添加自定义样式
  const initStyles = () => {
    const styleId = "notification-dialog-styles";
    if (document.getElementById(styleId)) return;

    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
      .notification-dialog .ant-modal-confirm-body {
        display: flex;
        align-items: flex-start;
        font-size: 14px;
      }

      .notification-dialog .ant-modal-confirm-title {
        font-size: 14px!important;
        font-weight: 500!important;
        color: rgba(0, 0, 0, 0.85);
      }

      .notification-dialog .ant-modal-confirm-content {
        margin-block-start: 29px;
        color: rgba(0, 0, 0, 0.85);;
      }

      .notification-dialog .ant-modal-confirm-btns {
        position: relative;
        margin-top: 24px;
        padding-top: 16px;
      }

      .notification-dialog .ant-modal-confirm-btns::before {
        content: '';
        position: absolute;
        top: 0;
        left: -24px;
        right: -24px;
        height: 1px;
        background-color: #f0f0f0;
      }

      

      .notification-dialog .ant-btn {
        outline: none !important;
      }

      .steps-content {
        margin-top: 16px;
        
      }
    `;
    document.head.appendChild(style);
  };

  // 生成对话框内容
  const generateContent = () => {
    return h("div", [
      h(
        "p",
        {},
        "为了确保您不错过任何重要信息，建议您在系统偏好设置中为「典枢」开启通知权限。"
      ),
      h("div", { class: "steps-content" }, [
        h("p", {}, "操作步骤："),
        h("p", {}, [
          "打开 ",
          h("span", { style: { fontWeight: 500 } }, "系统偏好设置"),
          " > ",
          h("span", { style: { fontWeight: 500 } }, "通知"),
          "，找到「典枢」，并开启通知。",
        ]),
      ]),
    ]);
  };

  // 显示通知权限对话框
  const showNotificationDialog = async () => {
    initStyles();

    const modalConfig = {
      title: "开启通知权限",
      icon: null,
      width: "520px",
      content: generateContent(),
      okText: "立即开启",
      cancelText: "稍后再说",
      class: "notification-dialog",
      closable: true,
      keyboard: true,
      maskClosable: true,
      onOk() {
        // 通知主进程用户同意开启权限
        window.electronAPI.writeNotificationConfig(true);
        window.electronAPI.openSystemNotificationSettings();
      },
      onCancel() {
        window.electronAPI.writeNotificationConfig(true);
      },
    };
    const status = await window.electronAPI.readNotificationConfig();
    if (!status) {
      Modal.confirm(modalConfig);
    }
  };

  return {
    showNotificationDialog,
  };
}
